import React from 'react'
import styled from 'styled-components'

const Header = styled.div`
  width: 100%;
  height: 36px;
  background-color: rgb(7, 58, 83);
  color: #ffffff;
  display: flex;
  align-items: center;
  font-size: 14px;
  margin-bottom: 16px;
  border-top: 1px solid #f0f0f0;
`

const PaneHeader = ({ leftComponent: Icon, headerText, rightComponent: RightComponent, branding }) => {
  console.log('PaneHeader branding', branding)
  let backgroundColor
  if (branding?.subHeaderBackground) {
    backgroundColor = branding.subHeaderBackground
  }
  return (
    <Header style={{ backgroundColor }}>
      <Icon sx={{ fill: '#fff', marginLeft: '16px', marginRight: '16px', width: '24px', height: '24px' }} />
      {headerText}
      {RightComponent && (
        <RightComponent style={{ position: 'absolute', right: 16, paddingRight: 16 }} />
      )}
    </Header>
  )
}

export default PaneHeader
